import React, { Component } from 'react';
import PersonalInfo from '../personal-info/personal-info';
import { Grid, Row, Col } from 'react-bootstrap';
import Particles from 'react-particles-js';

import './header.css';

class Header extends Component {
    render() {
        return (
            <div className="header-wrapper">

                <Particles height="99vh" params={
                    {
                        "particles": {
                            "number": {
                                "value": 50,
                                "density": {
                                    "enable": true,
                                    "value_area": 800
                                }
                            },
                            "color": {
                                "value": "#ffffff"
                            },
                            "opacity": {
                                "value": 0.5
                            },
                            "size": {
                                "value": 3,
                            },
                            "move": {
                                "speed": 1,
                            }
                        },
                        "retina_detect": true
                    }
                } />
                <Grid fluid={true} className="">
                    <Row className="personal-info-container">
                        <Col>
                            <PersonalInfo />
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/header/header.js